import React from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { getFlattenedRoutes, RouteConfig } from '../../routes';
import { ProtectedRoute, PageGuard } from '../common/security/ProtectedRoute';

const AppContent: React.FC = () => {
  const routeElements: RouteConfig[] = getFlattenedRoutes();
  const location = useLocation();
  const routed = useRoutes(
    routeElements.map(r => ({
      path: r.path,
      element: r.path === '/login' ? (
        r.element
      ) : (
        // Merkezî izin denetimi: login kontrolü + sayfa read izni (GUARD_EXEMPT_PATHS hariç)
        <ProtectedRoute>
          <PageGuard>{r.element}</PageGuard>
        </ProtectedRoute>
      )
    })) as any
  );

  if (location.pathname === '/login') {
    return <>{routed}</>;
  }

  return (
    <div className="content-container">
      {routed}
    </div>
  );
};

export default AppContent;